import React, { useState, useEffect } from "react";
import * as firebase from "firebase";
import { Redirect } from "react-router-dom";
import { Layout, Row, Col, Card, message, Modal } from "antd";

import AddStateForm from "../Components/AddStateForm";
import Header from "../Components/Header";

const { Content } = Layout;

const AddStateCollection = () =>  {
  const [loggedIn, setLoggedIn] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Get User from localstorage
    let user = localStorage.getItem("User");
    if (user) {
      setLoggedIn(true);
      setUser(JSON.parse(user));
    } else {
      setLoggedIn(false);
    }
  }, []);

  const logout = () => {
    firebase
      .auth()
      .signOut()
      .then(function () {
        // Sign-out successful.
        localStorage.clear();
        setLoggedIn(false);
      })
      .catch(function (error) {
        // An error happened.
        console.error(error);
      });
  };

    if (loggedIn === null) return <div />;
    if (loggedIn === false) return <Redirect to={"/"} />;
    return (
      <Layout className="layout" style={{ background: "#1f2228" }}>
        <Header logout={logout} componentName="LatestArticlePage" />
        <Content style={{ padding: "0 10px", background: "#1f2228" }}>
          <div className="site-layout-content">
            <Row>
              <Col span={24}>
                <Card style={{ borderRadius: "15px" }}>
                  <AddStateForm />
                </Card>
              </Col>
            </Row>
          </div>
        </Content>
      </Layout>
  )
}

export default AddStateCollection;